import { env } from '@homestake/towers';
import {
  browserProfilingIntegration,
  browserTracingIntegration,
  captureConsoleIntegration,
  contextLinesIntegration,
  extraErrorDataIntegration,
  httpClientIntegration,
  init,
  moduleMetadataIntegration,
  replayCanvasIntegration,
  replayIntegration,
  reportingObserverIntegration,
} from '@sentry/react';

init({
  dsn: env.VITE_SENTRY_DSN,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [
    // Session replay and canvas recording
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    replayCanvasIntegration(),

    // Performance monitoring - lightweight for static apps
    browserTracingIntegration(),
    browserProfilingIntegration(),

    // Console capturing for debugging
    captureConsoleIntegration({
      levels: ['error', 'warn', 'info', 'log'],
    }),

    // Source code context for better error reporting
    contextLinesIntegration(),

    // Enhanced error data extraction
    extraErrorDataIntegration({
      depth: 5,
    }),

    // HTTP request capturing for failed requests
    httpClientIntegration({
      failedRequestStatusCodes: [400, 599],
    }),

    // Browser reporting API integration
    reportingObserverIntegration(),

    // Module metadata for better stack traces
    moduleMetadataIntegration(),
  ],

  // Optimized sampling rates for production static app
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

  // Session replay configuration - balanced approach
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Additional optimizations for static apps
  beforeSend(event) {
    // Filter out noisy errors in production
    if (
      import.meta.env.PROD &&
      event.exception?.values?.[0]?.stacktrace?.frames?.some((frame) =>
        frame.filename?.includes('extension://')
      )
    ) {
      return null;
    }
    return event;
  },

  // Environment detection
  environment: import.meta.env.PROD ? 'production' : 'development',
});
